export const PageDataState = {
    Searchs: {
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ นามสกุล',
            value: '',
            placeholder: 'ชื่อ นามสกุล',
        },
        start_register_date: {
            type: 'text',
            id: 'start_register_date',
            label: 'เริ่มต้น',
            value: '',
            placeholder: 'เริ่มต้น',
        },
        end_register_date: {
            type: 'text',
            id: 'end_register_date',
            label: 'สิ้นสุด',
            value: '',
            placeholder: 'สิ้นสุด',
        },
        position_id: {
            type: 'select',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            placeholder: 'ตำแหน่ง',
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            placeholder: 'อีเมล',
        },
        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            placeholder: 'เบอร์ติดต่อ',
        },
        username: {
            type: 'text',
            id: 'username',
            label: 'บัญชีผู้ใช้',
            value: '',
            placeholder: 'บัญชีผู้ใช้',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            placeholder: 'สถานะ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ นามสกุล',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        cardid: {
            type: 'text',
            id: 'cardid',
            label: 'หมายเลขบัตรประชาชน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 13,
                maxLength: 13
            },
            error: { status: null, msg: '' }
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'สถานประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        position_id: {
            type: 'select',
            id: 'position_id',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        username: {
            type: 'text',
            id: 'username',
            label: 'บัญชีผู้ใช้',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 100
            },
            error: { status: null, msg: '' }
        },
        password: {
            type: 'password',
            id: 'password',
            label: 'รหัสผ่าน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 8,
                maxLength: 100
            },
            error: { status: null, msg: '' }
        },
        new_password: {
            type: 'password',
            id: 'new_password',
            label: 'รหัสผ่านใหม่',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 8,
                maxLength: 100
            },
            error: { status: null, msg: '' }
        },
        register_date: {
            type: 'text',
            id: 'register_date',
            label: 'วันที่ลงทะเบียน',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        profile_img: {
            type: 'file',
            id: 'profile_img',
            label: 'รูปภาพโปรไฟล์',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}